import { SimpleChanges } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Utils } from '../utils';

export function createMinValidator(min: number): ValidatorFn | null {
  return (control: AbstractControl) => {
    if (Utils.isNumber(control.value) && control.value < min) {
      return {
        minError: {
          minValue: min,
          value: control.value,
        },
      };
    }
    return null;
  };
}

export function createMaxValidator(max: number): ValidatorFn | null {
  return (control: AbstractControl) => {
    if (Utils.isNumber(control.value) && control.value > max) {
      return {
        maxError: {
          maxValue: max,
          value: control.value,
        },
      };
    }
    return null;
  };
}

export const Helper = {
  anyChanges,
  createNumericRegex,
};

function anyChanges(properties: string[], changes: SimpleChanges): boolean {
  for (const property of properties) {
    if (changes[property] !== undefined) {
      return true;
    }
  }
  return false;
}

function createNumericRegex(hasDecimal: boolean, hasSign: boolean): RegExp {
  let regexString = '^';
  if (hasSign) {
    regexString += '-?';
  }

  regexString += '(?:(?:\\d+';
  if (hasDecimal) {
    regexString += '(\\.\\d*)?';
  }

  regexString += ')|(?:\\.\\d*))?$';
  return new RegExp(regexString);
}
